export const noUndefined = (obj: object): object => {
  const filteredObject = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== undefined) {
      filteredObject[key] = obj[key];
    }
  });
  return filteredObject;
};
